import {
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  Grid,
  Input,
  TextField,
  Typography,
} from "@mui/material";

import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import { ChangeEvent, useEffect, useState } from "react";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import CancelIcon from "@mui/icons-material/Cancel";
import MainContainer from "../../../layout/MainContainer";
import { useNavigate, useParams } from "react-router-dom";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useEditUserMutation, useLazyGetUserByIdQuery } from "../../../services/users";
import { CommonBody, UserData } from "../../../types/General";
import { showError, showToast } from "../../../constants/toast";
import { UploadMedia } from "../../../utils/mediaUpload";
import { generateEncryptedKeyBody } from "../../../utils/crypto";
const UsersForm = () => {
  const { id } = useParams();
  const [showAlert, setShowAlert] = useState(false);
  const [phoneCode, setPhoneCode] = useState("+91");
  const [image, setImage] = useState<string>("");
  const [userData, setUserData] = useState<UserData>();
  const [getUserById, { isLoading }] = useLazyGetUserByIdQuery();
  const [editUser] = useEditUserMutation();
  const navigate = useNavigate();


  const handleClose = () => {
    setShowAlert(false);
  };
 

  const getUserDetail = async (id: string) => {
    try {
      const response = await getUserById({
        id: id,
      }).unwrap();
      if (response?.statusCode === 200) {
        setUserData(response?.data);
        setPhoneCode(response?.data?.countryCode || "+91");
        setImage(response?.data?.image || "");
      }
    } catch (error: any) {
      console.log(error, "errror");
      showError(error?.data?.message || "");
    }
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: userData?.email || "",
      fullName: userData?.fullName || "",
      phone: userData?.phone || "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .required("Email is required")
        .matches(
          /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i,
          "Enter a valid email address"
        ),
      fullName: Yup.string()
        .required("Full name is required")
        .max(30, "Maximum 60 character are allowed")
        .min(2, "Minimum 2 characters are required"),

      phone: Yup.string()
        .required("Phone number is required")
        .min(6, "Phone number must be at least 6 characters")
        .max(16, "Phone number must be at least 16 characters"),
    }),
    onSubmit: async (values) => {
      formik.setSubmitting(true);

      const data = {
        image: image,
        email: formik.values.email,
        fullName: formik.values.fullName,
        countryCode: (phoneCode.includes("+") ? "" : "+") + phoneCode,
        phone: formik.values.phone,
      };

      try {
        let encryptedBody = generateEncryptedKeyBody(data) as CommonBody;
        const response = await editUser({ id: `${id}`, body: encryptedBody }).unwrap();
        showToast(response?.message || "Customer Updated Successfully");
        navigate("/manage-customers");
      } catch (error: any) {
        showError(error?.data?.message || "");
        console.log(error);
      }
    },
  });

  const handleChangePhone = (phone: any, country: any) => {
    formik.setFieldValue("phone", phone?.replace(country.dialCode, ""));
    setPhoneCode(country?.dialCode);
  };

  const handleImageUpload = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const files = event.target;
    const file = files?.files?.length ? files?.files[0] : "";
    const res = await UploadMedia(file);
    if (res?.statusCode === 200) {
      setImage(res?.data);
    } else {
      showError(res?.message);
    }
  };

  useEffect(() => {
    if (id) {
      getUserDetail(id);
    }
  }, []);

  return (
    <>
      <div>
        <div className="main_loyout">
          <div className="dashboard">
            <h1 className="mn_hdng"> Edit User Profile</h1>
            <Button
              className="btn btn_primary"
              onClick={() => {
                navigate("/manage-customers");
              }}
            >
              Back
            </Button>
          </div>
          <Card className="cards">
            <form onSubmit={formik.handleSubmit}>
              <CardContent sx={{ p: 1 }}>
                <Grid container spacing={2}>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Typography className="custom_label">Image</Typography>
                    {image ? (
                      <div className="upload_image_preview">
                        <CardMedia component="img" image={image} alt="photo" />
                        <CancelIcon
                          sx={{ cursor: "pointer" }}
                          onClick={() => {
                            setImage("");
                            // setFileName("");
                          }}
                        />
                      </div>
                    ) : (
                      <Box className="upload_image">
                        <label htmlFor="icon-button-file">
                          <Input
                            sx={{ display: "none" }}
                            id="icon-button-file"
                            type="file"
                            inputProps={{
                              accept: "image/png,image/jpeg",
                            }}
                            onChange={handleImageUpload}
                          />
                          <Button component="span" className="upload_image_btn">
                            <img
                              src={
                                image
                                  ? image
                                  : "/static/images/user_placeholder.png"
                              }
                              alt=""
                            />
                            <CameraAltIcon />
                          </Button>
                        </label>
                      </Box>
                    )}
                  </Grid>
                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <Typography className="custom_label">Customer Name</Typography>
                    <TextField
                      hiddenLabel
                      className="text_field"
                      type={"text"}
                      name="fullName"
                      variant="outlined"
                      fullWidth
                      placeholder="Full name"
                      id="fullName"
                      onBlur={formik.handleBlur}
                      value={formik.values.fullName}
                      onChange={(val) => formik.handleChange(val)}
                      helperText={formik.touched.fullName && formik.errors.fullName}
                      inputProps={{ maxLength: 60 }}
                    ></TextField>
                  </Grid>
                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <Typography className="custom_label">Email</Typography>
                    <TextField
                      hiddenLabel
                      className="text_field"
                      type={"email"}
                      name="email"
                      variant="outlined"
                      fullWidth
                      placeholder="Email"
                      id="email"
                      onBlur={formik.handleBlur}
                      value={formik.values.email}
                      onChange={formik.handleChange}
                      helperText={formik.touched.email && formik.errors.email}
                    ></TextField>
                  </Grid>
                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <Typography className="custom_label">
                      Phone Number
                    </Typography>
                    <PhoneInput
                      enableSearch={true}
                      country={"us"}
                      placeholder="Phone Number"
                      inputClass="phoneInput"
                      value={phoneCode + formik.values.phone}
                      inputStyle={{ width: "100%" }}
                      onChange={(phone, country) =>
                        handleChangePhone(phone, country)
                      }
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.phone && formik.errors.phone ? (
                      <h6 className="err_msg">
                        {formik.touched.phone && formik.errors.phone}
                      </h6>
                    ) : (
                      ""
                    )}
                  </Grid>
                </Grid>
                <div className="form_btn">
                  <Button
                    size="large"
                    type="submit"
                    className="btn btn_primary"
                  >
                    Save
                  </Button>
                </div>
              </CardContent>
            </form>
          </Card>
        </div>
     </div>
    </>
  );
};

export default UsersForm;
